/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Spin,
  Tabs,
  Modal,
  DatePicker,
} from 'antd';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  RedoOutlined,
} from '@ant-design/icons';
import Select from 'components/Select';
import { onError, onSuccess } from 'utils/handlers';
import { getEstadosGlobales } from 'api/catalogos/index';
import Table from 'components/Table';
import {
  getEvaluacionesAsistencia,
} from 'api/catalogos/TiposDeEvaluacionAsistencia';
import {
  ESTATUS_ACTIVO, ESTATUS_AUTORIZADO, ESTATUS_CANCELADO, ESTATUS_INACTIVO,
} from 'utils/constants';
import ModalConfirmation from 'components/ModalConfirmation';
import ModalDelete from 'components/ModalDelete';
import FormSubmitControls from 'components/FormSubmitControls';
import {
  autorizarIncidenciaRelacion,
  cancelarIncidenciaRelacion,
  reactivarIncidenciaRelacion,
  deleteIncidenciaRelacion,
  getIncidenciaRelacion, getIncidenciasRelaciones, getIncidenciasRelacionesPag, patchIncidenciaRelacion, postIncidenciaRelacion,
} from 'api/configuraciones/clock/Incidencias/IncidenciaRelacion';
import { formatReceived, formatReceivedValues } from 'utils/formatValues';
import moment from 'moment/moment';
import { getConfiguracionIncidencias } from 'api/nominas/incidencias/configuracionIncidencias';

export const relacionConfigPermission = {
  permissionModel: 'incidenciarelacion',
  catalogsModels: [],
  tabsModels: [],
};

const RelacionConfigReloj = ({ permission }) => {
  const [form] = Form.useForm();
  const [isAdding, setAdding] = useState(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [evaluacionesAsistencia, setEvaluacionesAsistencia] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [incidencia, setIncidencia] = useState([]);
  const [estados, setEstados] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [visibleCancelar, setVisibleCancelar] = useState(false);
  const [visibleReactivar, setVisibleReactivar] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [visibleConfirmInactivo, setVisibleConfirmInactivo] = useState(false);
  const [disableFields, setDisableFields] = useState(false);
  const [pageActual, setPageActual] = useState(1);

  const formInstances = [
    form,
  ];

  const fetchPaginated = async (page = 1, q = null) => {
    try {
      setLoading(true);

      const cleanPage = Number(String(page).replace(/\D/g, ''));
      const _data = await getIncidenciasRelacionesPag({ page: cleanPage, ...q });

      const { results } = _data;

      setSelectedRowKeys([]);
      setPageActual(cleanPage);
      setData({ ..._data, results: [...results] });
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    const _data = await getIncidenciasRelaciones();
    setData(formatReceived(_data));
    setLoading(false);
  };
  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const [
        _evaluacionesAsistencia,
        _incidencias,
        _data,
        _estados,
      ] = await Promise.all([
        getEvaluacionesAsistencia({ estados_globales: ESTATUS_AUTORIZADO }),
        getConfiguracionIncidencias({ estados_globales: ESTATUS_AUTORIZADO }),
        getIncidenciasRelaciones(),
        getEstadosGlobales(),
      ]);
      if (mounted) {
        setEvaluacionesAsistencia(_evaluacionesAsistencia);
        setIncidencia(_incidencias);
        setData(_data);
        setEstados(_estados);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setVisible(false);
    setVisibleAutorizar(false);
    setVisibleCancelar(false);
    setVisibleReactivar(false);
    setDisableFields(false);
    setSelectedRowKeys([]);
    setSelectedData({});
  };
  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    setAdding(false);
    const [key] = selectedRowKeys;
    const match = responseData || data?.results?.find((item) => item.id === key);
    const _relacionConfigReloj = await getIncidenciaRelacion(match.id);

    if (!evaluacionesAsistencia.length) {
      await getEvaluacionesAsistencia({ estados_globales: ESTATUS_AUTORIZADO }).then(setEvaluacionesAsistencia);
    }
    setTimeout(() => {
      if (_relacionConfigReloj) {
        const formValues = {
          // Convierte el arreglo de tipos de evaluación de asistencia en un arreglo de IDs
          concepto_de_evaluacion: _relacionConfigReloj.concepto_de_evaluacion?.id,

          incidencia: _relacionConfigReloj.incidencia?.id,

          // Convierte la fecha de vigencia final a objeto moment si existe, si no null
          vigencia_final: _relacionConfigReloj.vigencia_final
            ? moment(_relacionConfigReloj.vigencia_final)
            : null,

          // Asigna el ID del estado global
          estados_globales: _relacionConfigReloj.estados_globales?.id, //  aquí sí es un ID
        };
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceived(formValues));
          setDisableFields(_relacionConfigReloj?.estados_globales?.id !== ESTATUS_ACTIVO);
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };
  const onClickAdd = () => {
    setAdding(true);
    form.resetFields();
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const onFinish = async (_continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();

      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;

      if (values.vigencia_final?.format) {
        values.vigencia_final = values.vigencia_final.format('YYYY-MM-DD');
      }
      const saved = await (key ? patchIncidenciaRelacion(key, values) : postIncidenciaRelacion(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteIncidenciaRelacion(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });

    const dataForForm = {
      ...record,
      vigencia_final: record.vigencia_final
        ? moment(record.vigencia_final)
        : null,
    };

    form.setFieldsValue(dataForForm);
  };
  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };
  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar un Incidencia Relacion ya autorizado');
        return;
      }
      const saved = await autorizarIncidenciaRelacion(key);
      if (saved) {
        const _data = await getIncidenciasRelaciones();
        setData(formatReceived(_data));
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onConfirmCancelar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede cancelar un Incidencia Relacion ya cancelado');
        return;
      }
      const saved = await cancelarIncidenciaRelacion(key);
      if (saved) {
        const _data = await getIncidenciasRelaciones();
        setData(formatReceived(_data));
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onConfirmReactivar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede reactivar un Incidencia Relacion ya activo');
        return;
      }
      const saved = await reactivarIncidenciaRelacion(key);
      if (saved) {
        const _data = await getIncidenciasRelaciones();
        setData(formatReceived(_data));
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'Concepto de Incidencia',
      dataIndex: 'concepto_de_evaluacion',
      key: 'concepto_de_evaluacion',
      width: 200,
      render: (_, record) => record?.concepto_de_evaluacion?.nombre || 'n/a',
    },
    {
      titleText: 'Incidencia',
      dataIndex: 'incidencia',
      key: 'incidencia',
      width: 200,
      render: (_, record) => `${record?.incidencia?.clave}  ${record?.incidencia?.concepto}` || 'n/a',
    },
    {
      titleText: 'Vigencia Final',
      dataIndex: 'vigencia_final',
      key: 'vigencia_final',
      width: 150,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 180,
      render: (_, record) => record?.estados_globales?.descripcion || 'n/a',
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
  };

  return (
    <Row align="center" justify="center" className="container">
      <Col span={24}>
        <Spin tip="Cargando..." spinning={loading}>
          <Table
            cols={columns}
            data={data?.results || []}
            pagination={false}
            paginationCallback={fetchPaginated}
            count={data?.count || 0}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
            }}
            customActions={[
              {
                onClick: () => setVisibleAutorizar(true),
                permission: { model: 'incidenciarelacion', action: 'autorizar' },
                icon: <CheckCircleOutlined />,
                text: 'Autorizar',
                disabledBySelection: true,
                disabled: selectedData?.estados_globales?.id !== ESTATUS_ACTIVO,
                className: 'success',
              },
              {
                onClick: () => setVisibleCancelar(true),
                permission: { model: 'incidenciarelacion', action: 'cancelar' },
                icon: <CloseCircleOutlined />,
                text: 'Cancelar',
                disabledBySelection: true,
                disabled: selectedData?.estados_globales?.id === ESTATUS_CANCELADO,
                className: 'cancel',
              },
              {
                onClick: () => setVisibleReactivar(true),
                permission: { model: 'incidenciarelacion', action: 'reactivar' },
                icon: <RedoOutlined />,
                text: 'Reactivar',
                disabledBySelection: true,
                disabled: selectedData?.estados_globales?.id !== ESTATUS_CANCELADO,
                className: 'success',
              },
            ]}
            disableDelete={selectedData?.estados_globales?.id !== ESTATUS_ACTIVO}
            permission={permission}
            allowExportParam={false}
          />
          <Modal
            open={open}
            closable={false}
            maskClosable={!loading}
            keyboard={!loading}
            footer={null}
            title={(
              <FormSubmitControls
                label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Relación De Conceptos De Evaluación`}
                onFinish={onFinish}
                onCancel={onCancel}
                loading={loading}
              />
            )}
            onCancel={onCancel}
            forceRender
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstErrorDatePicker
              name="Relacion"
              initialValues={{
                estados_globales: ESTATUS_ACTIVO,
              }}
            >
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="concepto_de_evaluacion"
                  label="Concepto de Incidencia"
                  rules={rules.required}
                  hasFeedback
                >
                  <Select
                    labelProp="nombre"
                    keyProp="id"
                    dataSource={evaluacionesAsistencia}
                    disabled={
                      disableFields
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="incidencia"
                  label="Incidencia"
                  rules={rules.required}
                  hasFeedback
                >
                  <Select
                    dataSource={incidencia.map((_incidencia) => ({ id: _incidencia?.id, descripcion: `${_incidencia?.clave}  ${_incidencia?.concepto}` }))}
                    disabled={
                      disableFields
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="vigencia_final"
                  label="Vigencia Final"
                  hasFeedback
                >
                  <DatePicker
                    allowClear
                    format="YYYY-MM-DD"
                    disabled={isAdding || selectedData?.estados_globales?.id === ESTATUS_INACTIVO}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="estados_globales"
                  label="Estatus"
                  hasFeedback
                >
                  <Select
                    labelProp="descripcion"
                    keyProp="id"
                    dataSource={estados}
                    activeInactive={selectedData?.estados_globales?.id === ESTATUS_ACTIVO}
                    disabled={selectedRowKeys.length <= 0 || disableFields}
                    onChange={(val) => setVisibleConfirmInactivo(val === ESTATUS_INACTIVO)}
                  />
                </Form.Item>
              </Col>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Modal>
          <ModalDelete
            onDelete={deleteItem}
            onCancel={() => setVisibleAlert(false)}
            open={visibleAlert}
            content={`Incidencia Relacion ${form.getFieldValue('concepto_de_evaluacion')?.nombre || ''}`}
            loading={loading}
          />
          <ModalConfirmation
            onFinish={onConfirmAutorizar}
            ConfirmAutorize
            onCancel={() => setVisibleAutorizar(false)}
            contentTitle={`Autorizar Incidencia Relacion ${form.getFieldValue('concepto_de_evaluacion')?.nombre || ''}`}
            open={visibleAutorizar}
            loading={loading}
          />
          <ModalConfirmation
            onFinish={onConfirmCancelar}
            ConfirmCancel
            onCancel={() => setVisibleCancelar(false)}
            contentTitle={`Cancelar Incidencia Relacion ${form.getFieldValue('concepto_de_evaluacion')?.nombre || ''}`}
            open={visibleCancelar}
            loading={loading}
          />
          <ModalConfirmation
            onFinish={onConfirmReactivar}
            onFinishIcon={<RedoOutlined />}
            onFinishText="Reactivar"
            onCancel={() => setVisibleReactivar(false)}
            contentTitle={`Reactivar Incidencia Relacion ${form.getFieldValue('concepto_de_evaluacion')?.nombre || ''}`}
            open={visibleReactivar}
            loading={loading}
          />
          <ModalConfirmation
            onFinish={() => setVisibleConfirmInactivo(false)}
            ConfirmInactive
            onCancel={() => {
              form.setFieldValue('estados_globales', ESTATUS_ACTIVO);
              setVisibleConfirmInactivo(false);
            }}
            open={visibleConfirmInactivo}
            contentTitle={`Inactivar Incidencia Relacion ${form.getFieldValue('concepto_de_evaluacion')?.nombre || ''}`}
            loading={loading}
          />
        </Spin>
      </Col>
    </Row>
  );
};

export default RelacionConfigReloj;
